"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var ProjectTypes_1 = require("Project/ProjectTypes");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var ClonerNotification_1 = __importDefault(require("Project/Service/ClonerNotification"));
var ProjectCreatedEvent_1 = require("@CommonFrontendBackend/Telemetry/ProjectCreatedEvent");
var Telemetry_1 = require("Telemetry");
var ProjectCreator = (function () {
    function ProjectCreator($state, $http, projectLimit, projectLiveLimit, upseller, apiBaseUrl, projectCounter, projectTelemetry, projectLiveCounter, styleWorker, notifyUser, usingFeature, showAcknowledgeModal, createUi) {
        var _this = this;
        this.$state = $state;
        this.$http = $http;
        this.projectLimit = projectLimit;
        this.projectLiveLimit = projectLiveLimit;
        this.upseller = upseller;
        this.apiBaseUrl = apiBaseUrl;
        this.projectCounter = projectCounter;
        this.projectTelemetry = projectTelemetry;
        this.projectLiveCounter = projectLiveCounter;
        this.styleWorker = styleWorker;
        this.notifyUser = notifyUser;
        this.usingFeature = usingFeature;
        this.showAcknowledgeModal = showAcknowledgeModal;
        this.createUi = createUi;
        this.hasReachLimit = function (projectToClone) {
            if (_this.projectLimit.hasHitLimit()) {
                return true;
            }
            if (_this.projectLiveLimit.hasHitLimit()) {
                if (!projectToClone) {
                    return true;
                }
                if (projectToClone && [Types_1.ProjectStatus.Live, Types_1.ProjectStatus.Accepted].includes(projectToClone.status)) {
                    return true;
                }
            }
            return false;
        };
        this.showUpsellerModal = function (projectToClone) {
            if (_this.hasReachLimit(projectToClone)) {
                _this.upseller.upsell({
                    showProjectUpsell: true,
                });
                return true;
            }
            return false;
        };
        this.create = function (parentFolderId) { return __awaiter(_this, void 0, Promise, function () {
            var response, createdProject, projectCreatedTelemetryData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.showUpsellerModal()) {
                            return [2];
                        }
                        return [4, this.$http.post("".concat(this.apiBaseUrl, "/projects"), {
                                extraData: { name: "Untitled", parentFolder: parentFolderId },
                            })];
                    case 1:
                        response = _a.sent();
                        createdProject = response.data;
                        projectCreatedTelemetryData = {
                            source: "new",
                            projectCreationSource: ProjectCreatedEvent_1.ProjectCreationSource.Ui,
                            projectCreationUiOrigin: ProjectCreatedEvent_1.ProjectCreationUiOrigin.Dashboard,
                            isProjectCreatedUsingForm: false,
                            projectCreationMethod: ProjectCreatedEvent_1.ProjectCreationMethod.New,
                            projectContentOrigin: ProjectCreatedEvent_1.ProjectContentOrigin.Blank,
                        };
                        this.onCreated({ createdProject: createdProject, telemetryData: projectCreatedTelemetryData });
                        this.$state.go("project", { id: createdProject._id });
                        return [2];
                }
            });
        }); };
        this.createWelcomePage = function () { return __awaiter(_this, void 0, Promise, function () {
            var response, createdProject, projectCreatedTelemetryData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.$http.post("".concat(this.apiBaseUrl, "/projects"), {
                            isWelcomePage: true,
                        })];
                    case 1:
                        response = _a.sent();
                        createdProject = response.data;
                        projectCreatedTelemetryData = {
                            projectCreationSource: ProjectCreatedEvent_1.ProjectCreationSource.Ui,
                            projectCreationUiOrigin: ProjectCreatedEvent_1.ProjectCreationUiOrigin.PageDashboardBanner,
                            isProjectCreatedUsingForm: false,
                            projectCreationMethod: ProjectCreatedEvent_1.ProjectCreationMethod.Clone,
                            projectContentOrigin: ProjectCreatedEvent_1.ProjectContentOrigin.HardcodedDataInCode,
                        };
                        this.onCreated({ createdProject: createdProject, telemetryData: projectCreatedTelemetryData });
                        this.$state.go("project", { id: createdProject._id });
                        return [2];
                }
            });
        }); };
        this.clone = function (project, cloneOrigin) { return __awaiter(_this, void 0, void 0, function () {
            var projectName, response, createdProject, uiOrigin, isTemplate, projectClonedTelemetryData, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.showUpsellerModal()) {
                            return [2];
                        }
                        if (this.usingFeature(FeatureFlag_1.default.OptOutNewEditor) && project.usingNewEditor) {
                            this.showAcknowledgeModal({
                                title: "This page can't be cloned",
                                explainer: this.createUi(require("Common/ModalAngular/NewEditorModal/NewEditorCloneModal.html")),
                                button: "Got it",
                            });
                            return [2];
                        }
                        projectName = "Cloned from: " + project.name;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, this.$http.post("".concat(this.apiBaseUrl, "/clone/").concat(project._id), {
                                name: projectName,
                                status: this.getStatus(project.status),
                            })];
                    case 2:
                        response = _b.sent();
                        createdProject = response.data;
                        this.notifyUser.success((0, ClonerNotification_1.default)("/#/page/".concat(createdProject._id), this.notifyUser.clearNotification));
                        uiOrigin = void 0;
                        switch (cloneOrigin) {
                            case Telemetry_1.ProjectCreatedCloneOrigin.Dashboard:
                            case Telemetry_1.ProjectCreatedCloneOrigin.DashboardFiltered:
                                uiOrigin = ProjectCreatedEvent_1.ProjectCreationUiOrigin.Dashboard;
                                break;
                            case Telemetry_1.ProjectCreatedCloneOrigin.EditorProjectOptionsMenu:
                                uiOrigin = ProjectCreatedEvent_1.ProjectCreationUiOrigin.Editor;
                                break;
                            case Telemetry_1.ProjectCreatedCloneOrigin.SearchOptionsMenu:
                                uiOrigin = ProjectCreatedEvent_1.ProjectCreationUiOrigin.Search;
                                break;
                            default:
                                uiOrigin = ProjectCreatedEvent_1.ProjectCreationUiOrigin.Unknown;
                        }
                        isTemplate = (_a = createdProject.tags) === null || _a === void 0 ? void 0 : _a.includes(ProjectTypes_1.SpecialProjectTag.Template);
                        projectClonedTelemetryData = {
                            source: "clone",
                            projectCreationSource: ProjectCreatedEvent_1.ProjectCreationSource.Ui,
                            projectCreationUiOrigin: uiOrigin,
                            isProjectCreatedUsingForm: false,
                            projectCreationMethod: ProjectCreatedEvent_1.ProjectCreationMethod.Clone,
                            projectContentOrigin: isTemplate ? ProjectCreatedEvent_1.ProjectContentOrigin.UserTemplate : ProjectCreatedEvent_1.ProjectContentOrigin.UserPage,
                        };
                        this.onCreated({
                            createdProject: createdProject,
                            telemetryData: projectClonedTelemetryData,
                            context: { cloneOrigin: cloneOrigin },
                        });
                        return [2, createdProject];
                    case 3:
                        err_1 = _b.sent();
                        this.notifyUser.error("An error occurred while cloning the page.");
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        this.cloneTemplate = function (template_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([template_1], __read(args_1), false), void 0, function (template, context) {
                var response, createdProject, templateClonedTelemetryData, err_2;
                if (context === void 0) { context = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.showUpsellerModal()) {
                                return [2];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4, this.$http.post("".concat(this.apiBaseUrl, "/clone/template/").concat(template._id), {
                                    name: "Cloned from: ".concat(template.name),
                                })];
                        case 2:
                            response = _a.sent();
                            createdProject = response.data;
                            templateClonedTelemetryData = {
                                projectCreationSource: ProjectCreatedEvent_1.ProjectCreationSource.Ui,
                                projectCreationUiOrigin: ProjectCreatedEvent_1.ProjectCreationUiOrigin.TemplateGallery,
                                isProjectCreatedUsingForm: false,
                                projectCreationMethod: ProjectCreatedEvent_1.ProjectCreationMethod.Clone,
                                projectContentOrigin: ProjectCreatedEvent_1.ProjectContentOrigin.UserTemplate,
                            };
                            return [4, this.postCreationFromTemplate(createdProject, template.name, templateClonedTelemetryData, context)];
                        case 3:
                            _a.sent();
                            return [2, createdProject];
                        case 4:
                            err_2 = _a.sent();
                            this.notifyUser.error("An error occurred while cloning that template.");
                            return [3, 5];
                        case 5: return [2];
                    }
                });
            });
        };
        this.postCreationFromTemplate = function (createdProject, templateName, telemetryData, context) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.styleWorker.addStyles()];
                    case 1:
                        _a.sent();
                        if (!!createdProject.usingTCDC) return [3, 3];
                        return [4, this.styleWorker.refreshCustomStylesList()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (context.isAccountTemplate) {
                            telemetryData.source = "user template";
                        }
                        else {
                            telemetryData.source = templateName;
                        }
                        this.onCreated({ createdProject: createdProject, telemetryData: telemetryData, context: context });
                        return [2];
                }
            });
        }); };
        this.onCreated = function (data) {
            var createdProject = data.createdProject, telemetryData = data.telemetryData, context = data.context;
            _this.projectCounter.add();
            if (createdProject.status === Types_1.ProjectStatus.Live) {
                _this.projectLiveCounter.add();
            }
            _this.projectTelemetry.projectCreated(telemetryData, context);
            return createdProject;
        };
        this.getStatus = function (status) {
            if ([Types_1.ProjectStatus.Draft, Types_1.ProjectStatus.Live].includes(status)) {
                return status;
            }
            else if (status === ProjectTypes_1.ProjectSearchResultStatus.Draft) {
                return Types_1.ProjectStatus.Draft;
            }
            else {
                return Types_1.ProjectStatus.Live;
            }
        };
    }
    return ProjectCreator;
}());
exports.default = ProjectCreator;
